import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

async function bootstrap() {
  await bootstrapApplication(AppComponent, appConfig)
    .catch(() => console.error('Erro ao iniciar a aplicação.'));
}

bootstrap();
